import type { MessageLocationPresentationDto } from "@multi-chat/shared";

type Translate = (key: string) => string;

export function locationCardTitle(
  presentation: MessageLocationPresentationDto,
  t: Translate,
): string {
  if (presentation.name) {
    return presentation.name;
  }
  if (presentation.address) {
    return presentation.address;
  }
  return t("inbox.location.droppedPin");
}

export function locationCardSubtitle(
  presentation: MessageLocationPresentationDto,
  title: string,
): string | null {
  if (presentation.address && presentation.address !== title) {
    return presentation.address;
  }
  if (!presentation.name && !presentation.address) {
    return `${presentation.latitude}, ${presentation.longitude}`;
  }
  return null;
}
